import axios from 'axios';

import portalEnvironment from '../Utils/baseURL';

const api = axios.create({
  client_id: 'cdf44a30-32a4-3930-9e82-4ee8a8a7d8f0',
  baseURL: portalEnvironment.BaseUrl,
  timeout: 300000,
});

export default api;
